import coreCapabilitiesData from 'src/data/core-capabilities-data.json'

function CoreCapabilites(){
    return(
        <div className="grid grid-cols-1 xl:grid-cols-2 w-5/6 xl:w-1/2 gap-[24px] auto-rows-fr">
            {coreCapabilitiesData.map(x => {
                return(
                    <div className='text-left flex flex-col md:flex-row gap-[16px] rounded-[16px] bg-bgCardBlack py-[28px] lg:py-[32px] px-[12px] lg:px-[16px] lg:justify-start items-center h-full'>
                        <img className= "h-fit" src={x.src}></img>
                        <div> 
                            <h1 className='text-[18px] lg:text-[24px] font-lora font-medium'>{x.title}</h1>
                            <p className='text-[12px]'>{x.description}</p>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default CoreCapabilites